import { render } from "./Printers.vue?vue&type=template&id=105f8c48&scoped=true"
import script from "./Printers.vue?vue&type=script&lang=js"
export * from "./Printers.vue?vue&type=script&lang=js"

import "./Printers.vue?vue&type=style&index=0&id=105f8c48&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105f8c48"]])

export default __exports__